// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ***************************************************************** CustomRulePacks *******************************************************************
// const INDEX_CustomRule_PACKS_SUCCESS = 'INDEX_CustomRule_PACKS_SUCCESS';
// const SHOW_GEO_SUCCESS = 'SHOW_GEO_SUCCESS';
// const SHOW_LOADING = 'SHOW_LOADING';
// const SHOW_CustomRule_PACK_SUCCESS = 'SHOW_CustomRule_PACK_SUCCESS';
// const STORE_CustomRule_PACK_SUCCESS = 'STORE_CustomRule_PACK_SUCCESS';
// const UPDATE_CustomRule_PACK_SUCCESS = 'UPDATE_CustomRule_PACK_SUCCESS';
// const DESTROY_CustomRule_PACK_SUCCESS = 'DESTROY_CustomRule_PACK_SUCCESS';
// ******************************************************************** CustomRulePackCustomRules **********************************************************************
// const INDEX_CustomRule_PACK_CustomRuleS_SUCCESS = 'INDEX_CustomRule_PACK_CustomRuleS_SUCCESS';
// const SHOW_CustomRule_PACK_CustomRule_SUCCESS = 'SHOW_CustomRule_PACK_CustomRule_SUCCESS';
// const STORE_CustomRule_PACK_CustomRule_SUCCESS = 'STORE_CustomRule_PACK_CustomRule_SUCCESS';
// const UPDATE_CustomRule_PACK_CustomRule_SUCCESS = 'UPDATE_CustomRule_PACK_CustomRule_SUCCESS';
// const DESTROY_CustomRule_PACK_CustomRule_SUCCESS = 'DESTROY_CustomRule_PACK_CustomRule_SUCCESS';

// const INDEX_CustomRule_PACK_CustomRuleS_FORM_SUCCESS = 'INDEX_CustomRule_PACK_CustomRuleS_FORM_SUCCESS';

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ***************************************************************** CustomRulePacks *******************************************************************
// /**
//  *
//  * @param {{data: Object}} payload
//  * @return {{type: String, payload: Object}}
//  * @private
//  */
// function _indexSuccess(payload) {
//   return {
//     type: INDEX_CustomRule_PACKS_SUCCESS,
//     payload: payload,
//   };
// }

// /**
//  *
//  * @param {{data: Object}} payload
//  * @return {{type: String, payload: Object}}
//  * @private
//  */
// function _showSuccess(payload) {
//   return {
//     type: SHOW_GEO_SUCCESS,
//     payload: payload,
//   };
// }

// /**
//  *
//  * @param {{data: Object}} payload
//  * @return {{type: String, payload: Object}}
//  * @private
//  */
// function _onLoad(payload) {
//   return {
//     type: SHOW_LOADING,
//     loading:payload,
//   };
// }

// /**
//  *
//  * @param {{data: Object}} payload
//  * @return {{type: String, payload: Object}}
//  * @private
//  */
// function _storeSuccess(payload) {
//   return {
//     type: STORE_CustomRule_PACK_SUCCESS,
//     payload: payload,
//   };
// }

// /**
//  *
//  * @param {{data: Object}} payload
//  * @return {{type: String, payload: Object}}
//  * @private
//  */
// function _updateSuccess(payload) {
//   return {
//     type: UPDATE_CustomRule_PACK_SUCCESS,
//     payload: payload.data,
//   };
// }

// /**
//  *
//  * @param {Number} payload
//  * @return {{type: String, payload: Object}}
//  * @private
//  */
// function _destroySuccess(payload) {
//   return {
//     type: DESTROY_CustomRule_PACK_SUCCESS,
//     payload: payload,
//   };
// }

// // ******************************************************************** CustomRulePackCustomRules **********************************************************************
// /**
//  *
//  * @param {{data: Object}} payload
//  * @return {{type: String, payload: Object}}
//  * @private
//  */
// function _indexCustomRulePackCustomRulesSuccess(payload) {
//   return {
//     type: INDEX_CustomRule_PACK_CustomRuleS_SUCCESS,
//     payload: payload,
//   };
// }

// /**
//  *
//  * @param {{data: Object}} payload
//  * @return {{type: String, payload: Object}}
//  * @private
//  */
// function _showCustomRulePackCustomRuleSuccess(payload) {
//   return {
//     type: SHOW_CustomRule_PACK_CustomRule_SUCCESS,
//     payload: payload.data,
//   };
// }

// /**
//  *
//  * @param {{data: Object}} payload
//  * @return {{type: String, payload: Object}}
//  * @private
//  */
// function _storeCustomRulePackCustomRuleSuccess(payload) {
//   return {
//     type: STORE_CustomRule_PACK_CustomRule_SUCCESS,
//     payload: payload.data,
//   };
// }

// /**
//  *
//  * @param {{data: Object}} payload
//  * @return {{type: String, payload: Object}}
//  * @private
//  */
// function _updateCustomRulePackCustomRuleSuccess(payload) {
//   return {
//     type: UPDATE_CustomRule_PACK_CustomRule_SUCCESS,
//     payload: payload.data,
//   };
// }

// /**
//  *
//  * @param {Number} payload
//  * @return {{type: String, payload: Object}}
//  * @private
//  */
// function _destroyCustomRulePackCustomRuleSuccess(payload) {
//   return {
//     type: DESTROY_CustomRule_PACK_CustomRule_SUCCESS,
//     payload: payload,
//   };
// }

// /**
//  *
//  * @param {{data: Object}} payload
//  * @return {{type: String, payload: Object}}
//  * @private
//  */
// function _showCustomRule(payload) {
//   return {
//     type: INDEX_CustomRule_PACK_CustomRuleS_FORM_SUCCESS,
//     payload: payload.data,
//   };
// }

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ***************************************************************** GeoFences *******************************************************************
// /**
//  *
//  * @param {Object} [params]
//  * @param {Function} [callback=(function())]
//  * @return {Function}
//  */
// export function GeoFences(params = {}, callback = () => {
// }) {
//   return (dispatch, gs, api) => {
//     dispatch(_onLoad(true))
//     api.get(`/ta/clockings?filter_groups[0][filters][0][key]=user_id&filter_groups[0][filters][0][value][0]=${[params.id ? params.id : null]}&filter_groups[0][filters][0][operator]=in&sort[0][key]=datetime&sort[0][direction]=DESC&limit=${params.limit}&page=${params.page-1}`)
//     .then((r) => {
//       dispatch(_showSuccess(r));
//       dispatch(_onLoad(false))
//         callback(false, r);
//       })
//       .catch((e) => {
//         callback(e);
//       });
//   };
// }

// /**
//  *
//  * @param {Object} data
//  * @param {Object} params
//  * @param {Function} [callback=(function())]
//  * @return {Function}
//  */
// export function AddGeoFences(params = {}, data, callback = () => {
// }) {
//   return (dispatch, gs, api) => {
//     api.post('/ta/GeoFences', { data:{geofence: data}
//     }).then((r) => {
//       dispatch(GeoFences({page:params.pageCount, limit:params.limit}));
//     }).catch((e) => {
//       console.log(e);
//     });
//   };
// }

// /**
//  *
//  * @param {Object} params
//  * @param {Object} data
//  * @param {Function} [callback=(function())]
//  * @return {Function}
//  */
// export function EditGeoFences(params = {}, data, callback = () => {
// }) {
//   return (dispatch, gs, api) => {
//    api.put(`/ta/GeoFences/${params.id}`, {data:{geofence:data}})
//       .then((r) => {
//         dispatch(GeoFences({page:params.pageCount, limit:params.limit}));
//       })
//       .catch((e) => {
//         console.log(e);
//       });
//   };
// }

// /**
//  *
//  * @param {Object} [params]
//  * @param {Function} [callback=(function())]
//  * @return {Function}
//  */
// export function DeleteGeoFences(params = {}, callback = () => {
// }) {
//   return (dispatch, gs, api) => {
//     api.delete(`/ta/GeoFences/${params.id}`)
//       .then((r) => {
//         dispatch(GeoFences({page:params.pageCount, limit:params.limit}));
//       })
//       .catch((e) => {
//         console.log(e);
//       });
//   };
// }

// /**
//  *
//  * @return {Function}
//  */
// export function emptyCustomRulePacks() {
//   return _indexSuccess({data: {rulePacks: []}, meta: {}});
// }

// /**
//  *
//  * @return {Function}
//  */
// export function emptyCustomRule() {
//   return _showCustomRule({data: {rule: {}}});
// }

// ******************************************************************** rulePackRules **********************************************************************

// /**
//  *
//  * @param {Object} data
//  * @param {Function} [callback=(function())]
//  * @return {Function}
//  */
// export function storeCustomRulePackCustomRule(data, callback = () => {
// }) {
//   return (dispatch, gs, api) => {
//     let loader = app.loading(app.translate('routes.home.requests.pattern.rule-pack.Adding New RulePackRule'));

//     api.post('/requests/rules/packs/rules', {data})
//       .then((r) => {
//         dispatch(_storeCustomRulePackCustomRuleSuccess(r));
//         loader.hide(() => app.message(app.translate('routes.home.requests.pattern.rule-pack.New RulePackRule Added Successfully')));
//         callback(r);
//       })
//       .catch((e) => {
//         loader.hide(() => app.error(
//           e, 'routes.home.requests.rule-pack', 'RulePack',
//           app.translate('routes.home.requests.pattern.rule-pack.Adding New RulePack Failed'),
//         ));
//       });
//   };
// }

// /**
//  *
//  * @param {Number} rulePackRule
//  * @param {Object} data
//  * @param {Function} [callback=(function())]
//  * @return {Function}
//  */
// export function updateCustomRulePackCustomRule(rulePackRule, data, callback = () => {
// }) {
//   return (dispatch, gs, api) => {
//     let loader = app.loading(app.translate('routes.home.requests.pattern.rule-pack.Updating RulePackRule'));

//     api.put(`/requests/rules/packs/rules/${rulePackRule}`, {data})
//       .then((r) => {
//         dispatch(_updateCustomRulePackCustomRuleSuccess(r));
//         loader.hide(() => app.message(app.translate('routes.home.requests.pattern.rule-pack.RulePackRule Updated Successfully')));
//         callback(r);
//       })
//       .catch((e) => {
//         loader.hide(() => app.error(
//           e, 'routes.home.requests.rule-pack', 'RulePack',
//           app.translate('routes.home.requests.pattern.rule-pack.Updating RulePackRule Failed'),
//         ));
//       });
//   };
// }

// /**
//  *
//  * @param {Number} rulePackRule
//  * @param {Function} [callback=(function())]
//  * @return {Function}
//  */
// export function destroyCustomRulePackCustomRule(rulePackRule, callback = () => {
// }) {
//   return (dispatch, gs, api) => {
//     let loader = app.loading(app.translate('routes.home.requests.pattern.rule-pack.Removing RulePackRule'));

//     api.delete(`/requests/rules/packs/rules/${rulePackRule}`)
//       .then((r) => {
//         dispatch(_destroyCustomRulePackCustomRuleSuccess(rulePackRule));
//         loader.hide(() => app.message(app.translate('routes.home.requests.pattern.rule-pack.RulePackRule Removed Successfully')));
//         callback(r);
//       })
//       .catch((e) => {
//         loader.hide(() => app.error(
//           e, 'routes.home.requests.rule-pack', 'RulePack',
//           app.translate('routes.home.requests.pattern.rule-pack.Removing RulePackRule Failed'),
//         ));
//       });
//   };
// }

// /**
//  *
//  * @return {{type: String, payload: Object}}
//  */
// export function emptyCustomRulePack() {
//   return _showSuccess({data: {rulePack: {}}});
// }

// /**
//  *
//  * @return {{type: String, payload: Object}}
//  */
// export function emptyCustomRulePackCustomRules() {
//   return _indexCustomRulePackCustomRulesSuccess({data: {rulePackRules: []}, meta: {}});
// }

// /**
//  *
//  * @return {{type: String, payload: Object}}
//  */
// export function emptyCustomRulePackCustomRule() {
//   return _showCustomRulePackCustomRuleSuccess({data: {rulePackRule: {}}});
// }

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
// /**
//  *
//  * @param {Object} state
//  * @param {{type: String, payload: Object}} action
//  * @return {Object}
//  */
// export default function reducer(state = {
//   rulePacks: [],
//   rulePack: {},
//   rulePackRules: [],
//   rulePackRule: {},
//   rule: {},
//   metaRulePacks: {},
//   metaRulePackRules: {},
//   workshops:[],
//   pageMeta:{}
// }, action) {
//   let rulePacks;
//   let rulePack;
//   let _index;
//   switch (action.type) {
// case INDEX_CustomRule_PACKS_SUCCESS:
//   return Object.assign({}, state, {
//     rulePacks: action.payload.data.requestRulePacks,
//     metaRulePacks: action.payload.meta,
//   });
// case STORE_CustomRule_PACK_SUCCESS:
//   rulePacks = app._.cloneDeep(state.rulePacks);
//   rulePacks.push(action.payload);
//   return Object.assign({}, state, {
//     rulePack: action.payload,
//     rulePacks,
//   });
//   case SHOW_CustomRule_PACK_SUCCESS:
//   return Object.assign({}, state, {
//     rulePack: action.payload.requestRulePack,
//   });
// case UPDATE_CustomRule_PACK_SUCCESS:
//   rulePacks = app._.cloneDeep(state.rulePacks);
//   rulePack = app._.cloneDeep(state.rulePack);
//   _index = rulePacks.findIndex((_rulePack) => _rulePack.id === action.payload.id);
//   rulePacks[_index] = action.payload;
//   rulePack.name = action.payload.name;
//   rulePack.description = action.payload.description;
//   return Object.assign({}, state, {
//     rulePack,
//     rulePacks,
//   });
// case DESTROY_CustomRule_PACK_SUCCESS:
//   rulePacks = app._.cloneDeep(state.rulePacks);
//   _index = rulePacks.findIndex((_rulePack) => _rulePack.id === action.payload);
//   rulePacks.splice(_index, 1);
//   return Object.assign({}, state, {
//     rulePacks,
//     rulePack: null,
//     rulePackRule: null,
//   });
// case INDEX_CustomRule_PACK_CustomRuleS_SUCCESS:
//   return Object.assign({}, state, {
//     rulePackRules: action.payload.data.rulePackRules,
//     metaRulePackRules: action.payload.meta,
//   });
// case SHOW_CustomRule_PACK_CustomRule_SUCCESS:
//   return Object.assign({}, state, {
//     rulePackRule: action.payload.requestRulePackRule,
//   });
// case STORE_CustomRule_PACK_CustomRule_SUCCESS:
//   rulePack = app._.cloneDeep(state.rulePack);
//   let _rules = [];
//   _rules.push(action.payload);
//   if (!app._.isEmpty(rulePack.rules)) {
//     _rules.push(...rulePack.rules);
//   }
//   rulePack.rules = _rules;
//   return Object.assign({}, state, {
//     rulePackRule: action.payload,
//     rulePack,
//   });
// case UPDATE_CustomRule_PACK_CustomRule_SUCCESS:
//   rulePack = app._.cloneDeep(state.rulePack);
//   _index = rulePack.rules.findIndex((_rulePackRule) => _rulePackRule.id === action.payload.id);
//   rulePack.rules[_index] = action.payload;
//   return Object.assign({}, state, {
//     rulePackRule: action.payload,
//     rulePack,
//   });
// case DESTROY_CustomRule_PACK_CustomRule_SUCCESS:
//   rulePack = app._.cloneDeep(state.rulePack);
//   _index = rulePack.rules.findIndex((_rulePackRule) => _rulePackRule.id === action.payload);
//   rulePack.rules.splice(_index, 1);
//   return Object.assign({}, state, {
//     rulePack,
//   });
// case INDEX_CustomRule_PACK_CustomRuleS_FORM_SUCCESS:
//   return Object.assign({}, state, {
//     rule: action.payload.rule,
//   });
//     case SHOW_LOADING:
//         return Object.assign({}, state, {
//           loading: action.loading,
//         });
//     case SHOW_GEO_SUCCESS:
//         return Object.assign({}, state, {
//           clockings: action.payload.data.clockings,
//           meta:  action.payload.meta,
//           loading: false,
//         });
//     default:
//       return state;
//   }
// }

// //Start//////////////////////////////////////////

// // -------------------------------------------------------------------- constants --------------------------------------------------------------------

// // *************************************************************** rulePacks assignment *****************************************************************
// const UPDATE_CustomRule_PACK_USER_ASSIGNMENT_SUCCESS = 'UPDATE_CustomRule_PACK_USER_ASSIGNMENT_SUCCESS';
// const UPDATE_CustomRule_PACK_POSITION_ASSIGNMENT_SUCCESS = 'UPDATE_CustomRule_PACK_POSITION_ASSIGNMENT_SUCCESS';

// // ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// // *************************************************************** rulePacks assignment *****************************************************************
// /**
//  *
//  * @param {{data: Object}} payload
//  * @return {{type: String, payload: Object}}
//  * @private
//  */
// function _updateUserSuccess(payload) {
//   return {
//     type: UPDATE_CustomRule_PACK_USER_ASSIGNMENT_SUCCESS,
//     payload: payload.data,
//   };
// }

// /**
//  *
//  * @param {{data: Object}} payload
//  * @return {{type: String, payload: Object}}
//  * @private
//  */
// function _updatePositionSuccess(payload) {
//   return {
//     type: UPDATE_CustomRule_PACK_POSITION_ASSIGNMENT_SUCCESS,
//     payload: payload.data,
//   };
// }

// // --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// // *************************************************************** rulePacks assignment *****************************************************************
// /**
//  *
//  * @param {Number} rulePack
//  * @param {Object} data
//  * @param {Object} [params={}]
//  * @param {Function} [callback=(function())]
//  * @return {Function}
//  */
// export function updateUsers(rulePack, data, params = {}, callback = () => {}) {
//   console.log("Users:", rulePack, data);
//   return (dispatch, gs, api) => {
//     if (app.can('RequestRulePack@setUsers')) {
//       let loader = app.loading(app.translate('routes.home.requests.pattern.rule-pack.Assigning RulePack Users'));

//       api.put(`/Ta/GeoFences/${rulePack}/Users`, { data: { users: data }, params })
//         .then((res) => {
//           dispatch(_updateUserSuccess(res));
//           loader.hide(() => app.message(app.translate('routes.home.requests.pattern.rule-pack.RulePack Users Assigned Successfully')));
//           callback(undefined, res);
//         })
//         .catch((err) => {
//           loader.hide(() => app.error(
//             err, 'routes.home.requests.rule-pack', 'RulePack',
//             app.translate('routes.home.requests.pattern.rule-pack.RulePack User Assignment Failed')
//           ));
//           callback(err);
//         });
//     }
//   };
// }

// /**
//  *
//  * @param {Number} rulePack
//  * @param {Object} data
//  * @param {Object} [params={}]
//  * @param {Function} [callback=(function())]
//  * @return {Function}
//  */
// export function updatePositions(rulePack, data, params = {}, callback = () => {}) {
//   return (dispatch, gs, api) => {
//     if (app.can('RequestRulePack@setPositions')) {
//       let loader = app.loading(app.translate('routes.home.requests.pattern.rule-pack.Assigning RulePack Positions'));

//       api.put(`/Ta/GeoFences/${rulePack}/Positions`, { data: { positions: data }, params })
//         .then((res) => {
//           dispatch(_updatePositionSuccess(res));
//           loader.hide(() => app.message(app.translate('routes.home.requests.pattern.rule-pack.RulePack Positions Assigned Successfully')));
//           callback(undefined, res);
//         })
//         .catch((err) => {
//           loader.hide(() => app.error(
//             err, 'routes.home.requests.rule-pack', 'RulePack',
//             app.translate('routes.home.requests.pattern.rule-pack.RulePack Position Assignment Failed')
//           ));
//           callback(err);
//         });
//     }
//   };
// }

// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ******************************************************************** clockings ********************************************************************
const INDEX_CLOCKINGS_SUCCESS = "INDEX_CLOCKINGS_SUCCESS";
const SHOW_CLOCKING_SUCCESS = "SHOW_CLOCKING_SUCCESS";
const SHOW_PICTURE_SUCCESS = "SHOW_PICTURE_SUCCESS";
const STORE_CLOCKING_CHECK_SUCCESS = "STORE_CLOCKING_CHECK_SUCCESS";
const UPDATE_CLOCKING_SUCCESS = "UPDATE_CLOCKING_SUCCESS";
const DESTROY_CLOCKING_SUCCESS = "DESTROY_CLOCKING_SUCCESS";
const DESTROY_ALL_CLOCKING_SUCCESS = "DESTROY_ALL_CLOCKING_SUCCESS";
const RESTORE_CLOCKING_SUCCESS = "RESTORE_CLOCKING_SUCCESS";
const ACCEPT_CLOCKING_SUCCESS = "ACCEPT_CLOCKING_SUCCESS";
const ACCEPT_ALL_CLOCKING_SUCCESS = "ACCEPT_ALL_CLOCKING_SUCCESS";
const SHOW_GEO_SUCCESS = "SHOW_GEO_SUCCESS";
const SHOW_LOADING = "SHOW_LOADING";
// ***************************************************************** clocking reasons ****************************************************************
const INDEX_CLOCKING_REASONS_SUCCESS = "INDEX_CLOCKING_REASONS_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ******************************************************************** clockings ********************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showGeoSuccess(payload) {
  return {
    type: SHOW_GEO_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _onLoad(payload) {
  return {
    type: SHOW_LOADING,
    loading: payload,
  };
}

/**
 *
 * @param {Array} payload
 * @return {{type: string, payload: *}}
 */
function _indexSuccess(payload) {
  return {
    type: INDEX_CLOCKINGS_SUCCESS,
    payload: { data: payload.data, meta: payload.meta },
  };
}

/**
 *
 * @param {Object} payload
 * @return {{type: string, payload: *}}
 */
function _showSuccess(payload) {
  return {
    type: SHOW_CLOCKING_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Object} payload
 * @return {{type: string, payload: *}}
 */
function _showSuccessPic(payload) {
  return {
    type: SHOW_PICTURE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSuccess(payload) {
  return {
    type: STORE_CLOCKING_CHECK_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateSuccess(payload) {
  return {
    type: UPDATE_CLOCKING_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroySuccess(payload) {
  return {
    type: DESTROY_CLOCKING_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroyAllSuccess(payload) {
  return {
    type: DESTROY_ALL_CLOCKING_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _restoreSuccess(payload) {
  return {
    type: RESTORE_CLOCKING_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {Number} payload
 * @param {String} status
 * @return {{type: String, payload: Object}}
 * @private
 */
function _acceptSuccess(payload, status) {
  return {
    type: ACCEPT_CLOCKING_SUCCESS,
    payload: { id: payload, status: status },
  };
}

/**
 *
 * @param {Number} payload
 * @param {String} status
 * @return {{type: String, payload: Object}}
 * @private
 */
function _acceptAllSuccess(payload, status) {
  return {
    type: ACCEPT_ALL_CLOCKING_SUCCESS,
    payload: { ids: payload, status: status },
  };
}

// ***************************************************************** clocking reasons ****************************************************************
/**
 *
 * @param {Array} payload
 * @return {{type: string, payload: *}}
 */
function _indexReasonsSuccess(payload) {
  return {
    type: INDEX_CLOCKING_REASONS_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

/**
 *
 * @param {Array} items
 * @param {Object} reasons
 * @return {Array} Edit Clocking
 */
function getEditClockings(items, reasons) {
  let temp = [];

  items?.map((item) => {
    temp.push(
      Object.assign({}, item, {
        className: item.deletedAt
          ? "record-deleted"
          : item.status
          ? `record-${item.status}`
          : "",
        rowSelectionDisabled: item.deletedAt ? true : false,
      })
    );
  });

  return temp;
}

// ******************************************************************** clockings ********************************************************************
/**
 *
 * @return {{type: string, payload: *}}
 */
export function emptyClockings() {
  return _indexSuccess({ data: { clockings: [] }, meta: {} });
}

/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function GeoFences(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    dispatch(_onLoad(true));
    api
      .get("/ta/clockings", { params })
      .then((r) => {
        dispatch(_showGeoSuccess(r));
        dispatch(_onLoad(false));
        callback(false, r);
      })
      .catch((e) => {
        callback(e);
      });
  };
}

/**
 *
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    // if (app.can('Clocking@forPerson') || app.fcan('Clocking@all') || app.can('Clocking@sub') || app.can('Clocking@self')) {
    api
      .get("/ta/clockings", { params })
      .then((res) => {
        dispatch(_indexSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        app.error(
          err,
          "routes.home.attendance.clocking",
          ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
          app.translate(
            "routes.home.attendance.clocking.Indexing Clockings Failed"
          )
        );
        callback(err);
      });
    // }
  };
}

/**
 *
 * @param {Number} clocking
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function show(clocking, callback = () => {}) {
  return (dispatch, gs, api) => {
    // if (app.can('Clocking@forPerson') || app.can('Clocking@all') || app.can('Clocking@sub') || app.can('Clocking@self')) {
    api
      .get(`/ta/clockings/${clocking}`, {
        params: {
          includes: ["type"],
        },
      })
      .then((res) => {
        dispatch(_showSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        app.error(
          err,
          "routes.home.attendance.clocking",
          ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
          app.translate(
            "routes.home.attendance.clocking.Indexing Clocking Failed"
          )
        );
        callback(err);
      });
    // }
  };
}

/**
 *
 * @param {Number} clocking
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showPicture(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    dispatch(_onLoad(true));
    // if (app.can('Clocking@forPerson') || app.can('Clocking@all') || app.can('Clocking@sub') || app.can('Clocking@self')) {
    api
      .get(`/ta/clockings/${params.Id}`)
      .then((res) => {
        dispatch(_showSuccessPic(res));
        dispatch(_onLoad(false));
        callback(undefined, res);
      })
      .catch((err) => {
        app.error(
          err,
          "routes.home.attendance.clocking",
          ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
          app.translate(
            "routes.home.attendance.clocking.Indexing Clocking Failed"
          )
        );
        callback(err);
      });
    // }
  };
}

/**
 *
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function emptyClocking(callback = () => {}) {
  return _showSuccess({ data: {} });
}

/**
 *
 * @param {Object} data
 * @param {Boolean} acceptAll
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, acceptAll, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Clocking@store")) {
      let loader = app.loading(
        app.translate("routes.home.attendance.clocking.Adding New Clocking")
      );
      let _path = "/ta/clockings";

      if (acceptAll) {
        _path = `${_path}?acceptAll=true`;
      }

      api
        .post(_path, { data })
        .then((res) => {
          dispatch(_storeSuccess(res));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.attendance.clocking.New Clocking Added Successfully"
              )
            )
          );
          callback(undefined, res.data);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.attendance.clocking",
              "خطا در ارسال اطلاعات",
              app.translate(
                "routes.home.attendance.clocking.Adding New Clocking Failed"
              )
            )
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Number} clocking
 * @param {Object} data
 * @param {Boolean} acceptAll
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function update(clocking, data, acceptAll, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Clocking@update")) {
      let loader = app.loading(
        app.translate("routes.home.attendance.clocking.Updating Clocking")
      );
      let _path = `/ta/clockings/${clocking}`;

      if (acceptAll) {
        _path = `${_path}?acceptAll=true`;
      }

      api
        .put(_path, { data })
        .then((res) => {
          dispatch(_updateSuccess(res));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.attendance.clocking.Clocking Updated Successfully"
              )
            )
          );
          callback(undefined, res.data);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.attendance.clocking",
              "عملیات برورسانی با شکست مواجه شد!",
              app.translate(
                "routes.home.attendance.clocking.Updating Clocking Failed"
              )
            )
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Number} clocking
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroy(clocking, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Clocking@destroy")) {
      let loader = app.loading(
        app.translate("routes.home.attendance.clocking.Removing Clocking")
      );

      api
        .delete(`/ta/clockings/${clocking}`)
        .then((res) => {
          dispatch(_destroySuccess(clocking));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.attendance.clocking.Clocking Removed Successfully"
              )
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.attendance.clocking",
              "عملیات حذف با شکست مواجه شد!",
              app.translate(
                "routes.home.attendance.clocking.Removing Clocking Failed"
              )
            )
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroyAll(params, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Clocking@destroy")) {
      let loader = app.loading(
        app.translate("routes.home.attendance.clocking.Removing Clocking")
      );

      api
        .delete(`/ta/clockings`, { params })
        .then((res) => {
          dispatch(_destroyAllSuccess(params));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.attendance.clocking.Clocking Removed Successfully"
              )
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.attendance.clocking",
              "عملیات حذف با شکست مواجه شد!",
              app.translate(
                "routes.home.attendance.clocking.Removing Clocking Failed"
              )
            )
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Number} clocking
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function restore(clocking, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Clocking@restore")) {
      let loader = app.loading(
        app.translate("routes.home.attendance.clocking.Restoring Clocking")
      );

      api
        .put(`/ta/clockings/${clocking}/restore`)
        .then((res) => {
          dispatch(_restoreSuccess(clocking));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.attendance.clocking.Clocking Restored Successfully"
              )
            )
          );
          callback(undefined, res.data);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.attendance.clocking",
              "عملیات بروزسانی با شکست مواجه شد!",
              app.translate(
                "routes.home.attendance.clocking.Restoring Clocking Failed"
              )
            )
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Number} clocking
 * @param {String} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function accept(clocking, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Clocking@approve")) {
      let loader = app.loading(
        app.translate(
          "routes.home.attendance.clocking.Changing Status Clocking"
        )
      );
      api
        .put(`/ta/clockings/${clocking}/approve`, {
          data: { acceptance: data },
        })
        .then((r) => {
          dispatch(_acceptSuccess(clocking, data));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.attendance.clocking.Clocking Changed Status Successfully"
              )
            )
          );
          callback(undefined, data);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.attendance.clocking",
              "عملیات بروزسانی با شکست مواجه شد!",
              app.translate(
                "routes.home.attendance.clocking.Changing Status Clocking Failed"
              )
            )
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Object} params
 * @param {String} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function acceptAll(params, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Clocking@approve")) {
      let loader = app.loading(
        app.translate(
          "routes.home.attendance.clocking.Changing Status Clocking"
        )
      );
      api
        .put(`/ta/clockings/approve`, { data: { acceptance: data }, params })
        .then((r) => {
          dispatch(_acceptAllSuccess(params, data));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.attendance.clocking.Clocking Changed Status Successfully"
              )
            )
          );
          callback(undefined, data);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.attendance.clocking",
              "Clocking",
              app.translate(
                "routes.home.attendance.clocking.Changing Status Clocking Failed"
              )
            )
          );
          callback(err);
        });
    }
  };
}

// ***************************************************************** clocking reasons ****************************************************************
/**
 *
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function indexReasons(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/ta/clockings/reasons", { params })
      .then((res) => {
        dispatch(_indexReasonsSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        app.error(
          err,
          "routes.home.attendance.clocking",
          "خطا در ارسال اطلاعات",
          app.translate(
            "routes.home.attendance.clocking.Indexing Clocking Reasons Failed"
          )
        );
        callback(err);
      });
  };
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(
  state = {
    clockings: [],
    clocking: {},
    picture: null,
    reasons: [],
    meta: {},
  },
  action
) {
  let clockings;
  let _index;
  let _clock;
  let _temp;

  switch (action.type) {
    case INDEX_CLOCKINGS_SUCCESS:
      clockings = getEditClockings(
        action.payload.data.clockings,
        state.reasons
      );
      return Object.assign({}, state, {
        clockings,
        meta: action.payload.meta,
      });
    case SHOW_CLOCKING_SUCCESS:
      return Object.assign({}, state, {
        clocking: action.payload.clocking,
      });
    case SHOW_PICTURE_SUCCESS:
      return Object.assign({}, state, {
        picture: action.payload.clocking,
      });
    case INDEX_CLOCKING_REASONS_SUCCESS:
      return Object.assign({}, state, {
        reasons: action.payload.clockingReasons,
      });
    case STORE_CLOCKING_CHECK_SUCCESS:
      clockings = app._.cloneDeep(state.clockings);
      clockings.unshift(action.payload);
      _clock = action.payload;
      _clock.className = _clock.deletedAt
        ? "record-deleted"
        : _clock.status
        ? `record-${_clock.status}`
        : "";
      _clock.rowSelectionDisabled = _clock.deletedAt ? true : false;
      return Object.assign({}, state, {
        clockings,
        clocking: _clock,
      });
    case UPDATE_CLOCKING_SUCCESS:
      clockings = app._.cloneDeep(state.clockings);
      _index = clockings.findIndex(
        (_clocking) => _clocking.id === action.payload.id
      );
      if (_index > -1) {
        _clock = action.payload;
        _clock.className = _clock.deletedAt
          ? "record-deleted"
          : _clock.status
          ? `record-${_clock.status}`
          : "";
        _clock.rowSelectionDisabled = _clock.deletedAt ? true : false;
        clockings[_index] = Object.assign({}, clockings[_index], _clock);
      }
      return Object.assign({}, state, {
        clockings,
      });
    case RESTORE_CLOCKING_SUCCESS:
      clockings = app._.cloneDeep(state.clockings);
      _index = clockings.findIndex(
        (_clocking) => _clocking.id === action.payload
      );
      if (_index > -1) {
        clockings[_index].className = clockings[_index].status
          ? `record-${clockings[_index].status}`
          : "";
        clockings[_index].deletedAt = undefined;
        clockings[_index].rowSelectionDisabled = false;
      }
      return Object.assign({}, state, {
        clockings,
      });
    case DESTROY_CLOCKING_SUCCESS:
      clockings = app._.cloneDeep(state.clockings);
      _index = clockings.findIndex(
        (_clocking) => _clocking.id === action.payload
      );
      if (_index > -1) {
        _clock = clockings[_index];
        _clock.className = "record-deleted";
        _clock.rowSelectionDisabled = true;
        _clock.deletedAt = "0000-00-00 00:00:00";
        clockings[_index] = _clock;
      }
      return Object.assign({}, state, {
        clockings,
      });
    case DESTROY_ALL_CLOCKING_SUCCESS:
      clockings = app._.cloneDeep(state.clockings);
      if (
        !app._.isEmpty(action.payload) &&
        action.payload.filterGroups &&
        action.payload.filterGroups[0] &&
        action.payload.filterGroups[0].filters &&
        action.payload.filterGroups[0].filters[0] &&
        action.payload.filterGroups[0].filters[0].value
      ) {
        _temp = action.payload.filterGroups[0].filters[0].value;
        for (let x in _temp) {
          _index = clockings.findIndex(
            (_clocking) => _clocking.id === _temp[x]
          );
          if (_index > -1) {
            _clock = clockings[_index];
            _clock.className = "record-deleted";
            _clock.rowSelectionDisabled = true;
            _clock.deletedAt = "0000-00-00 00:00:00";
            clockings[_index] = _clock;
          }
        }
      }
      return Object.assign({}, state, {
        clockings,
      });
    case ACCEPT_CLOCKING_SUCCESS:
      clockings = app._.cloneDeep(state.clockings);
      _index = clockings.findIndex(
        (_clocking) => _clocking.id === action.payload.id
      );
      if (_index > -1) {
        _clock = clockings[_index];
        _clock.className = _clock.deletedAt
          ? "record-deleted"
          : `record-${action.payload.status}`;
        _clock.rowSelectionDisabled = _clock.deletedAt ? true : false;
        _clock.status = action.payload.status;
        clockings[_index] = _clock;
      }
      return Object.assign({}, state, {
        clockings,
      });
    case ACCEPT_ALL_CLOCKING_SUCCESS:
      clockings = app._.cloneDeep(state.clockings);
      if (
        !app._.isEmpty(action.payload.ids) &&
        action.payload.ids.filterGroups &&
        action.payload.ids.filterGroups[0] &&
        action.payload.ids.filterGroups[0].filters &&
        action.payload.ids.filterGroups[0].filters[0] &&
        action.payload.ids.filterGroups[0].filters[0].value
      ) {
        _temp = action.payload.ids.filterGroups[0].filters[0].value;
        for (let x in _temp) {
          _index = clockings.findIndex(
            (_clocking) => _clocking.id === _temp[x]
          );
          if (_index > -1) {
            _clock = clockings[_index];
            _clock.className = _clock.deletedAt
              ? "record-deleted"
              : `record-${action.payload.status}`;
            _clock.rowSelectionDisabled = _clock.deletedAt ? true : false;
            _clock.status = action.payload.status;
            clockings[_index] = _clock;
          }
        }
      }
      return Object.assign({}, state, {
        clockings,
      });
    case SHOW_LOADING:
      return Object.assign({}, state, {
        loading: action.loading,
      });
    case SHOW_GEO_SUCCESS:
      return Object.assign({}, state, {
        clockings: action.payload.data.clockings,
        meta: action.payload.meta,
        loading: false,
      });
    default:
      return state;
  }
}
